import { render, staticRenderFns } from "./PodtEditMain.vue?vue&type=template&id=5a246e49&scoped=true&"
import script from "./PodtEditMain.vue?vue&type=script&lang=js&"
export * from "./PodtEditMain.vue?vue&type=script&lang=js&"
import style0 from "./PodtEditMain.vue?vue&type=style&index=0&id=5a246e49&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a246e49",
  null
  
)

export default component.exports